import Sloth from 'slothd/dist/Sloth';
import Raphael from 'raphael';
import MapData from './data';
import './mapselector.scss';

@Sloth.component({
    defaultOptions: {
        mapdata : MapData,
        width : 650,
        borderColor : '#eee',
        fontColor : '#fff',
        fillColor : '#628caf',
        fillColor2 : '#4d7ca3',
        borderWidth : 1,
        fontSize : '12px'
    }
})

class MapSelector {
    constructor() {
        this.areaList = [];
    }

    onInit() {
        $(this.dom).addClass('MapSelector').css({ zoom: this.options.width / 650 });
        const Paper = Raphael(this.dom, 650, 548);
        const data = this.options.mapdata;

        for (const map of data) {
            const maparea = new MapArea(Paper, map, this.options, this.onClick.bind(this));
            this.addArea(maparea);
        }
    }

    addArea(maparea) {
        this.areaList.push(maparea);
    }

    onClick(item) {
        $(this.dom).triggerHandler('mapclick', item);
    }
}


class MapArea {
    constructor(paper, item, props, onClick) {
        this.paper = paper;
        this.item = item;
        this.props = props;
        this.onAreaClick = onClick;

        this.path = this.renderPath();
        this.path.click(() => this.onClick());
        this.path.hover(() => this.onMouseIn(), () => this.onMouseOut());
        this.cordin = this.path.getBBox();

        setTimeout(() => {
            this.text = this.renderText();
            this.text.click(() => this.onClick());
            this.text.hover(() => this.onMouseIn(), () => this.onMouseOut());
        });
    }

    renderPath() {
        return this.paper.path(this.item.path).attr({
            fill: this.props.fillColor,
            'stroke-width':this.props.borderWidth,
            stroke:this.props.borderColor
        });
    }

    renderText() {
        const offsetX = this.item.offsetX || 0;
        const offsetY = this.item.offsetY || 0;

        const x = this.cordin.x + this.cordin.width / 2 + offsetX;
        const y = this.cordin.y + this.cordin.height / 2 + offsetY;

        return this.paper.text(x, y, this.item.name).attr({
            'font-size': this.props.fontSize,
            'font-weight': 'bold',
            cursor:'default',
            fill:this.props.fontColor
        });
    }

    onClick() {
        this.onAreaClick(this.item);
    }

    onMouseIn() {
        this.path.attr({
            fill: this.props.fillColor2
        });
    }

    onMouseOut() {
        this.path.attr({
            fill: this.props.fillColor
        });
    }
}



/** WEBPACK FOOTER **
 ** ./components/MapSelector/mapselector.js
 **/